import { QueryClient, QueryClientProvider } from "@tanstack/react-query"
import { ThemeProvider } from "next-themes"
import { Toaster } from "sonner"

import ReduxProvider from "./ReduxProvider"
import RoutedApp from "./RoutedApp"

// ----------------------------------------------------------------------------

const queryClient = new QueryClient()

// ----------------------------------------------------------------------------

export default function App() {
  return (
    <ThemeProvider attribute="class" defaultTheme="light">
      <QueryClientProvider client={queryClient}>
        <ReduxProvider>
          <RoutedApp />
        </ReduxProvider>
      </QueryClientProvider>

      <Toaster richColors />
    </ThemeProvider>
  )
}
